import { FormattedMessage } from "react-intl";
import { PageContainer } from "@packsize/components";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";

import { EmManualControlCard } from "./em-manual-control-card";

export interface ManualMachineControlTemplateProps {
	readonly machineIds: readonly string[];
}

export const ManualMachineControlTemplate = ({ machineIds }: ManualMachineControlTemplateProps) => (
	<PageContainer>
		<Stack spacing={2}>
			<Typography variant="h1">
				<FormattedMessage id="Manual Machine Control" defaultMessage="Manual Machine Control" />
			</Typography>

			{machineIds.length === 0 && (
				<Card variant="outlined" data-testid="manual-machine-control__empty-state">
					<CardContent
						component={Grid}
						container
						justifyContent="center"
						alignItems="center"
						direction="column"
						sx={{
							minHeight: 240,
						}}
					>
						<Typography variant="h2">
							<FormattedMessage
								id="No machines support manual control"
								defaultMessage="No machines support manual control"
							/>
						</Typography>
						<Typography color="text.secondary">
							<FormattedMessage
								id="The current machine group has no EM machines available for manual control"
								defaultMessage="The current machine group has no EM machines available for manual control."
							/>
						</Typography>
					</CardContent>
				</Card>
			)}

			{machineIds.length > 0 && (
				<Stack spacing={2} data-testid="manual-machine-control__cards">
					{machineIds.map((machineId) => (
						<EmManualControlCard key={machineId} machineId={machineId} />
					))}
				</Stack>
			)}
		</Stack>
	</PageContainer>
);
